module.exports = __webpack_public_path__ + "static/1-Multipurpose-Hall-Image-f5cb23c8bbe20ff3457cc58610f42dd1.jpg";